export const FETCH_START = 'FETCH_START';
export const FETCH_STOP = 'FETCH_STOP';
export const API_TIMEOUT = 90 * 1000; // 90 seconds
